// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a86a48e7","239":"0c0a04e8","447":"42f3b965","732":"0406a391","762":"26c72250","967":"2983ed66"}[chunkId] + ".chunk.js";
};